import { render, staticRenderFns } from "./Schools.vue?vue&type=template&id=53adfd52&scoped=true&"
import script from "./Schools.vue?vue&type=script&lang=js&"
export * from "./Schools.vue?vue&type=script&lang=js&"
import style0 from "./Schools.vue?vue&type=style&index=0&id=53adfd52&lang=scss&scoped=true&"
import style1 from "./Schools.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53adfd52",
  null
  
)

export default component.exports